import React from 'react';

import { getSearchCampaignEditStepConfigs } from '../steps/step-configs';
import { SEARCH_CAMPAIGN_EDIT_WIZARD_STEP_PATHS } from '../steps/step-utils';
import { EditWizard } from './edit-wizard';
import { SEARCH_WIZARD_TYPE_NAME } from './constants';

export const SearchCampaignEditWizard = (props) => {
  const { permissions } = props || {};
  const stepConfigs = getSearchCampaignEditStepConfigs(permissions);
  return (
    <EditWizard
      stepConfigs={stepConfigs}
      scenarioName="SearchCampaignEditRevamp"
      activityName="SearchCampaignEditWizard"
      wizardTypeName={SEARCH_WIZARD_TYPE_NAME.SEARCH_CAMPAIGN_EDIT_WIZARD}
      wizardLoggerFlowName="SearchCampaign"
      wizardLoggerSubFlowName="SearchCampaignEdit"
      wizardLoggerStepToPage={SEARCH_CAMPAIGN_EDIT_WIZARD_STEP_PATHS}
      perfMarkerName="SearchCampaignEditWizard"
      onDoneNavigateToSiteMapId="adgroups"
      {...props}
    />
  );
};
